var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('v-container',[_c('v-row',_vm._l((_vm.loader.items),function(i){return _c('v-col',{key:i},[_c('v-skeleton-loader',{staticClass:"ma-2",attrs:{"type":_vm.loader.template}})],1)}),1)],1):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }